import { patch } from '@ngxs/store/operators';
import { InstitucionService } from '../../services/institucion/institucion.service';
import { Injectable } from '@angular/core';
import { State, Action, StateContext, Store } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { ServiciosActions } from './servicios.actions';
import { state } from '@angular/animations';

export class ServiciosStateModel {
  public estado!: boolean;
  public mensaje!: string;
  public unidades!: Unidad[];
  public unidadSeleccionada!: Unidad;
}
export class Unidad {
  public nombre!: string;
  public slug!: string;
  public descripcion!: string;
  public unidades_usuarios!: UnidadesUsuarios[];
}
export class UnidadesUsuarios {
  public usuario!: any;
}
const defaults = {
  estado: false,
  mensaje: 'Ocurrió un error, intenta nuevamente.',
  unidades: [],
  unidadSeleccionada: null
};

@State<ServiciosStateModel>({
  name: 'servicios',
  defaults,
})
@Injectable()
export class ServiciosState {

  constructor(
    private institucionSerivce: InstitucionService,
    private store: Store
  ) { }

  @Action(ServiciosActions.LoadUnidades)
  LoadUnidades({ getState, setState }: StateContext<ServiciosStateModel>,
    { slug }: ServiciosActions.LoadUnidades) {
    return this.institucionSerivce.getInstitucionUnidad(slug).pipe(
      tap(
        (result) => {
          const state = getState();
          setState({
            ...state,
            estado: result.estado,
            mensaje: result.mensaje,
            unidades: result.institucion.unidades,
          })
        },
        (err) => { }
      )
    );
  }
  @Action(ServiciosActions.SelectUnidad)
  selectUnidad({setState}: StateContext<ServiciosStateModel>,
    { slugUnidad }: ServiciosActions.SelectUnidad) {
      const unidades = this.store.selectSnapshot((state: any) => state.servicios.unidades);
      const unidadFiltrada: Unidad[] = unidades.filter((unidad: Unidad) => unidad.slug === slugUnidad);
      setState(
        patch({
          unidadSeleccionada: unidadFiltrada[0]
        })
      )
    }
}
